import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSHomeAddressData, type EnrollmentHYCSHomeAddressSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSHomeAddressDataMock: EnrollmentHYCSHomeAddressData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/home-address',
  enrollmentData: {
    applicationId: '123',
  },
}

export const submitEnrollmentHYCSHomeAddressDataMock: EnrollmentHYCSHomeAddressSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/verify-identity',
  enrollmentData: {
    applicationId: '123',
  },
}

export const mockGetEnrollmentHYCSHomeAddressData = graphql.mutation('getEnrollmentHYCSHomeAddressData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSHomeAddressDataMock } })
})

export const mockSubmitEnrollmentHYCSHomeAddressData = graphql.mutation('submitEnrollmentHYCSHomeAddressData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSHomeAddressDataMock } })
})

export const mockEnrollmentHYCSHomeAddress = [
  mockGetEnrollmentHYCSHomeAddressData,
  mockSubmitEnrollmentHYCSHomeAddressData,
]
